import { requestUploadUrl } from './requestUploadUrl';
import { uploadToS3 } from './uploadToS3';

/**
 * Uploads an image file to S3. First requests an upload URL from
 * the server, then uploads the image. Returns the key for the S3
 * asset, which is used by the endpoint that sends images off to
 * OCR for processing.
 *
 * @param {Object} params
 * @param {File} params.file - Image file to upload
 * @param {string} params.fileName - Original filename
 * @param {string} params.contentType - MIME type (e.g., 'image/jpeg')
 * @returns Promise<Object> { key: string }
 */
export const uploadImage = async ({ file, fileName, contentType }) => {
  try {
    const { url, key } = await requestUploadUrl({ contentType, fileName });

    await uploadToS3({ url, file, contentType });

    return { key };
  } catch (e) {
    throw new Error('Failed to upload image', { cause: e });
  }
};
